/* eslint-disable @typescript-eslint/naming-convention */
export enum NodeTypes {
    Article = 'Article',
    Dashboard = 'Dashboard',
    DPPArticle = 'DPPArticle',
    DPPPrivateArea = 'DPPPrivateArea',
    DPPHome = 'DPPHome',
    Epq = 'Epq',
    Error = 'Error',
    Form = 'Form',
    FormOverview = 'FormOverview',
    Home = 'Home',
    Legal = 'Legal',
    MyBig = 'MyBig',
    News = 'News',
    PersonalData = 'PersonalData',
    PublicDelivery = 'PublicDelivery',
    Search = 'Search',
}
